import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {initItemcardImages} from "./custom/itemcardImages";
import {inizializeCollectionSwiper} from "./custom/collectionSpielraeume";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();
    inizializeCollectionSwiper();
});


window.addEventListener("resize",(event) => {
    initItemcardImages();
});